require("./sitio");

// slide
import '@splidejs/splide/dist/css/splide.min.css';
// slide
const Splide = require('@splidejs/splide').default;

let slide_quines_somos = new Splide("#slide-quienes-somos", {
    type: "slide",
    perPage: 3,
    autoplay: false,
    arrows: true,
    gap: "30px",
    perMove: 1,
    pagination: false,
    breakpoints: {
        992: {
            type: "loop",
            perPage: 2,
        },
        768: {
            type: "loop",
            perPage: 1,
        },
    },
}).mount();
